export class UserLoginApi {
  public login: string
  public password: string
}